export const API_BASE = (() => {
    return `${location.protocol}//${location.host}`
})();
